<template>
  <div class="eleicao-conselho">
    <div class="row">
      <public-header :title="`Seção ${secao}`" class="public-header">
        <div class="col-xs-12">
          <p>
            <span class="destaque-header">{{ dadosSecao.unidade }}</span
            ><br />
            <span class="destaque-header">{{ dadosSecao.endereco }}</span
            ><br />
          </p>
        </div>
        <div class="col-xs-12 col-sm-6">
          <p>
            Esta seção possui
            <span class="destaque-header">{{
              Number(dadosSecao.aptos).toLocaleString()
            }}</span>
            eleitores aptos para votação, dos quais
            <span class="destaque-header">{{
              Number(dadosSecao.compareceram).toLocaleString()
            }}</span>
            compareceram, totalizando
            <span class="destaque-header">{{
              (
                dadosSecao.total_nominais +
                dadosSecao.total_brancos +
                dadosSecao.total_nulos
              ).toLocaleString()
            }}</span>
            votos.
          </p>
          <p>
            Abaixo você pode acompanhar como foi a votação por candidato nesta
            seção.
          </p>
        </div>
      </public-header>
    </div>
    <div class="container">
      <Breadcrumb :links="breadcrumb" />
      <ListaCandidatosGeral
        :title="'Resultado nesta Seção'"
        :listaCandidatos="candidatosSecao"
        :votosNominaisTotais="Number(dadosSecao.total_nominais)"
      />
    </div>
  </div>
</template>

<script>
import {
  PublicHeader,
  Breadcrumb,
  ListaCandidatosGeral
} from '../../../components'
import { mapState } from 'vuex'

export default {
  components: { PublicHeader, Breadcrumb, ListaCandidatosGeral },
  created() {
    const { secao } = this.$route.params

    if (!secao || !this.votos.length) {
      this.$router.push({ name: 'eleicao_conselho' })
    } else {
      this.secao = secao
    }
  },
  data() {
    return {
      isLoading: true,
      secao: 0,
      candidato: {
        total_votos: 0
      }
    }
  },
  methods: {},
  computed: {
    ...mapState({
      candidatos: ({ eleicoes_conselho }) => eleicoes_conselho.candidatos,
      votos: ({ eleicoes_conselho }) => eleicoes_conselho.votos
    }),
    candidatosSecao() {
      const finder = voto => {
        return voto.secoes_id === this.dadosSecao.id
      }
      const result = this.candidatos.map(candidato => {
        return {
          ...candidato,
          total_votos: (candidato.votos.find(finder) || { total_votos: 0 })
            .total_votos
        }
      })

      result.sort((a, b) => {
        if (a.total_votos < b.total_votos) {
          return 1
        }

        if (a.total_votos > b.total_votos) {
          return -1
        }

        const dateA = new Date(a.data_nascimento)
        const dateB = new Date(b.data_nascimento)
        if (dateA > dateB) {
          return 1
        }

        if (dateA < dateB) {
          return -1
        }

        return 0
      })

      return result.map((candidato, index) => {
        return {
          ...candidato,
          posicao: index + 1
        }
      })
    },
    dadosSecao() {
      const finder = item => {
        return item.numero === this.secao
      }

      const result = this.votos.find(finder)

      return { ...result }
    },
    breadcrumb() {
      return [
        {
          label: 'Eleições - Conselho Tutelar',
          named_link: { name: 'eleicao_conselho' }
        },
        {
          label: `Seção ${this.secao}`
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/public/eleicao_conselho/DetalheSecao.vue